import { type IconProp } from '@fortawesome/fontawesome-svg-core';

export type MapStatusBarToggleSwitchItem = {
  label: string;
  isVisible: boolean;
  onVisibilityChange: (isVisible: boolean) => void;
  switch: {
    offIcon: IconProp;
    onIcon: IconProp;
  };
};

export enum MapStatusBarItemRemoveType {
  DeletePermanently = 'DeletePermanently',
  RemoveFromMap = 'RemoveFromMap',
  Undo = 'Undo',
}

export enum MapStatusBarItemCollapsedState {
  Collapsed = 'Collapsed',
  Expanded = 'Expanded',
}

export type MapStatusBarLabelItem = {
  icon?: IconProp;
  label: string;
  isVisible?: boolean;
  onRemove?: () => void;
  onVisibilityChange?: (isVisible: boolean) => void;
  onClick?: () => void;
  removeType: MapStatusBarItemRemoveType | null;
  // Set only on items that summarize several collapsed items. Renders a collapse/expand toggle.
  collapsedState?: MapStatusBarItemCollapsedState;
  onCollapse?: (collapsedState: MapStatusBarItemCollapsedState) => void;
};

export type MapStatusBarItem = MapStatusBarToggleSwitchItem | (MapStatusBarLabelItem & {
  switch?: undefined;
});
